/**
 * UserPeriodListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Row,
  Col,
  Table,
  Title,
  ExpandableContainer,
} from 'components';
import { Button, DatePicker, Radio, Select, InputNumber } from 'antd';
import { getDateRange } from 'utils';
import moment from 'moment';

const UserPeriodListPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    modal,
    users,
    grades,
    page,
    count,
    expand,
    onUpdateQuery,
    onChange,
    searchInputValue,
    onSubmit,
    onSearch,
    parameter,
    navigate,
    onUsedCoupon,
  } = props;
  /* ===== STATE ===== */
  const [isExpanded, setIsExpanded] = React.useState(false);
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 150,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },

    couponLayout: {
      width: '100%',
      backgroundColor: '#f4f4f4',
      borderLeft: '20px solid #ddd',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 20,
      paddingLeft: 20,
      position: 'relative',
      top: 0,
      left: 0,
    },
    couponTitle: {
      fontSize: 18,
      fontWeight: 700,
      marginBottom: 16,
    },
    couponStatus: {
      color: 'var(--black-color)',
      fontSize: 16,
      lineHeight: 1.75,
    },
    couponDate: {
      fontSize: 14,
      fontWeight: 700,
      color: 'var(--dark-gray-color)',
    },
  };

  /**
   * 등급 Select Item
   * --
   */
  const selectGradeList = grades
    ?.slice()
    ?.sort((a, b) => a?.grade_id - b?.grade_id)
    ?.map((grade) => ({
      label: grade?.grade_name,
      value: grade?.grade_name,
    }));

  const regionOptions = [
    { label: '전체', value: null },
    { label: '서울', value: '서울' },
    { label: '경기', value: '경기' },
    { label: '인천', value: '인천' },
    { label: '강원', value: '강원' },
    { label: '대전', value: '대전' },
    { label: '충북', value: '충북' },
    { label: '충남', value: '충남' },
    { label: '세종', value: '세종' },
    { label: '대구', value: '대구' },
    { label: '경북', value: '경북' },
    { label: '경남', value: '경남' },
    { label: '울산', value: '울산' },
    { label: '부산', value: '부산' },
    { label: '광주', value: '광주' },
    { label: '전북', value: '전북' },
    { label: '전남', value: '전남' },
    { label: '제주', value: '제주' },
  ];

  const formItem = [
    {
      label: '회원가입일',
      form: [
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(0);

                onChange('joinStartDate', moment(start).format('YYYY-MM-DD'));
                onChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(7);

                onChange('joinStartDate', moment(start).format('YYYY-MM-DD'));
                onChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(30);

                onChange('joinStartDate', moment(start).format('YYYY-MM-DD'));
                onChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(90);

                onChange('joinStartDate', moment(start).format('YYYY-MM-DD'));
                onChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                onChange('joinStartDate', '');
                onChange('joinEndDate', '');
              }}
            >
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
                {...(searchInputValue?.joinStartDate
                  ? {
                      value: searchInputValue?.joinStartDate
                        ? moment(searchInputValue?.joinStartDate)
                        : '',
                    }
                  : {})}
                onChange={(date, dateString) =>
                  onChange('joinStartDate', dateString)
                }
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
                {...(searchInputValue?.joinEndDate
                  ? {
                      value: searchInputValue?.joinEndDate
                        ? moment(searchInputValue?.joinEndDate)
                        : '',
                    }
                  : {})}
                onChange={(date, dateString) =>
                  onChange('joinEndDate', dateString)
                }
              />
            </>
          ),
        },
      ],
    },
    {
      label: '등급달성일',
      form: [
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(0);

                onChange('joinStartDate', moment(start).format('YYYY-MM-DD'));
                onChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(7);

                onChange('joinStartDate', moment(start).format('YYYY-MM-DD'));
                onChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(30);

                onChange('joinStartDate', moment(start).format('YYYY-MM-DD'));
                onChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(90);

                onChange('joinStartDate', moment(start).format('YYYY-MM-DD'));
                onChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                onChange('joinStartDate', '');
                onChange('joinEndDate', '');
              }}
            >
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
                {...(searchInputValue?.joinStartDate
                  ? {
                      value: searchInputValue?.joinStartDate
                        ? moment(searchInputValue?.joinStartDate)
                        : '',
                    }
                  : {})}
                onChange={(date, dateString) =>
                  onChange('joinStartDate', dateString)
                }
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
                {...(searchInputValue?.joinEndDate
                  ? {
                      value: searchInputValue?.joinEndDate
                        ? moment(searchInputValue?.joinEndDate)
                        : '',
                    }
                  : {})}
                onChange={(date, dateString) =>
                  onChange('joinEndDate', dateString)
                }
              />
            </>
          ),
        },
      ],
    },
    {
      label: '지역',
      form: [
        {
          input: (
            <Select
              size="large"
              value={searchInputValue?.region ?? null}
              options={regionOptions}
              style={{ ...styles.form.input.large }}
              onChange={(e) => onChange('region', e)}
            />
          ),
        },
      ],
    },
    {
      label: '나이',
      form: [
        {
          input: (
            <>
              <InputNumber
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large, marginRight: 0 }}
                value={searchInputValue?.ageStart}
                onChange={(e) => onChange('ageStart', e)}
                maxLength={2}
                min={0}
                max={searchInputValue?.ageEnd ?? 99}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <InputNumber
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large }}
                value={searchInputValue?.ageEnd}
                onChange={(e) => onChange('ageEnd', e)}
                maxLength={2}
                min={searchInputValue?.ageStart ?? 0}
              />
              <p style={{ ...styles.form.text }}>세</p>
            </>
          ),
        },
      ],
    },
    {
      label: '성별',
      form: [
        {
          input: (
            <Radio.Group value={searchInputValue?.gender ?? null}>
              <Radio
                value={null}
                onChange={(e) => onChange('gender', e.target.value)}
              >
                전체
              </Radio>
              <Radio
                value={'남'}
                onChange={(e) => onChange('gender', e.target.value)}
              >
                남
              </Radio>
              <Radio
                value={'여'}
                onChange={(e) => onChange('gender', e.target.value)}
              >
                여
              </Radio>
            </Radio.Group>
          ),
        },
      ],
    },
  ];

  // 임시 tableData 생성
  const tableData = [
    {
      name: '홍길동',
      account: 'hong123',
      phone: '010-1234-5678',
      email: 'hong@example.com',
      grade: '2024-01-01',
      area: '서울',
      age: 30,
      gender: '남',
    },
    {
      name: '김영희',
      account: 'kim456',
      phone: '010-9876-5432',
      email: 'kim@example.com',
      grade: '2024-02-01',
      area: '부산',
      age: 28,
      gender: '여',
    },
    {
      name: '박철수',
      account: 'park789',
      phone: '010-1111-2222',
      email: 'park@example.com',
      grade: '2024-03-01',
      area: '대구',
      age: 35,
      gender: '남',
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>기간별 회원 목록</Title>
          <Content
            maxWidth={'100%'}
            borderRadius={4}
            padding={0}
            backgroundColor={'none'}
          >
            {/* <Empty
              style={{
                height: 500,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
              description={
                <>
                  <Title align={'center'}>개발중입니다.</Title>
                </>
              }
            ></Empty> */}

            {/* 검색필터 */}
            <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
              <ExpandableContainer
                borderRadius={4}
                padding={20}
                isExpand={expand === 'Y' ? true : false}
                setIsExpand={() =>
                  onUpdateQuery('expand', expand === 'Y' ? 'N' : 'Y')
                }
              >
                {formItem.map((_item, _index) => (
                  <div
                    key={`form_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 0px',
                    }}
                  >
                    <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                      <label>{_item.label}</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {_item.form.map((_subitem, _subkey) => (
                        <React.Fragment key={`input_${_subkey}`}>
                          {_subitem.input}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </ExpandableContainer>

              {/* 검색/초기화 버튼 */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  marginTop: 48,
                  marginBottom: 40,
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  style={{
                    ...styles.button,
                    background: 'var(--primary-color)',
                  }}
                  //onClick={() => onSearch()}
                >
                  검색
                </Button>
                <Button
                  size="large"
                  style={{ ...styles.button }}
                  onClick={() => navigate('/users/period')}
                >
                  초기화
                </Button>
              </div>
              {/* 검색/초기화 버튼 끝 */}

              {/* 검색결과 */}
              <Content maxWidth={'100%'} borderRadius={4} padding={20}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 20,
                    justifyContent: 'space-between',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <h4
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        marginRight: 20,
                      }}
                    >
                      검색 결과 총{' '}
                      <span>
                        {/* {users?.length} */}
                        {tableData.length}
                      </span>
                      건
                    </h4>
                    <Button size="large" style={{ marginRight: 8 }}>
                      엑셀다운로드
                    </Button>
                  </div>
                  <div>
                    <Select
                      value={Number(count)}
                      options={[
                        { label: '10 / page', value: 10 },
                        { label: '30 / page', value: 30 },
                        { label: '50 / page', value: 50 },
                        { label: '100 / page', value: 100 },
                      ]}
                      onChange={(e) => onUpdateQuery('count', e)}
                    />
                  </div>
                </div>

                <Table
                  data={tableData}
                  columns={[
                    {
                      title: '이름',
                      key: 'name',
                    },
                    {
                      title: '아이디',
                      key: 'account',
                    },
                    {
                      title: '연락처',
                      key: 'phone',
                    },
                    {
                      title: '이메일',
                      key: 'email',
                    },
                    {
                      title: '등급달성일',
                      key: 'grade',
                    },
                    {
                      title: '지역',
                      key: 'area',
                      //width: 300,
                    },
                    {
                      title: '나이',
                      key: 'age',
                    },
                    {
                      title: '성별',
                      key: 'gender',
                    },
                  ]}
                />
                {/* <Pagination
                  total={tableData.length}
                  //total={users?.length}
                  align="center"
                  style={{
                    marginTop: 40,
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  current={page}
                  pageSize={count}
                  onChange={(p) => onUpdateQuery('page', p)}
                /> */}
              </Content>
              {/* 검색결과 끝 */}
            </Content>
          </Content>
        </Col>
      </Row>
    </Content>
  );
};

export default UserPeriodListPresenter;
